import BaseTable, {FieldType} from "../table/BaseTable.tsx";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";
import {useEffect, useMemo, useState} from "react";
import NewApplicationModal from "../modal/NewApplicationModal";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store";
import {application} from "@/store/modules/application.ts";
import NewEntityModal from "../modal/NewEntityModal.tsx";
import {useNavigate} from "react-router-dom";
import {Application, ReadApplicationResponse} from "@/model/response/application/ReadApplicationResponse.ts";
import {entity} from "@/store/modules/entity.ts";
import NavBarHeading from "@/components/menu/NavBarHeading.tsx";
import {team} from "@/store/modules/team.ts";
import {base} from "@/store/modules/base.ts";
import {ModalConstant} from "@/util/constant/ModalConstant.ts";
import DashboardTabs from "@/components/pages/DashboardTabs.tsx";
import {useFirstRender} from "@/util/useFirstRender.tsx";

export default function ApplicationWorkspace() {
    const applicationState = useSelector((state: RootState) => state.application);
    const workspaceState = useSelector((state: RootState) => state.workspace);
    const [showModal, setShowModal] = useState(false);
    const [applicationData, setApplicationData] = useState<Partial<ReadApplicationResponse> | null>({})
    const [openModal, setOpenModal] = useState(false);
    const isFirstRender = useFirstRender()
    const dispatch = useDispatch<any>();


    const refreshPage = () => {
        window.location.reload()
    }

    const items = useMemo(() => {
        if (isFirstRender) {
            dispatch(application.action.readByWorkspaceId({applicationWorkspaceId: workspaceState.selectedWorkspace.workspaceId}))
            return []
        }
        return applicationState?.applicationsByWorkSpaceId?.length !== 0 ? [...applicationState.applicationsByWorkSpaceId].reverse() : []
    }, [applicationState.applicationsByWorkSpaceId, dispatch, isFirstRender, workspaceState.selectedWorkspace.workspaceId])




    useEffect(() => {
        dispatch(team.action.read)
    }, []);


    const navigate = useNavigate()

    const fields: FieldType[] = [
        {
            label: "Application Name", key: "applicationName", onClick: (data: Application) => {
                navigate(RouteConstant.dashboard.entity.path)
                dispatch(application.mutation.selectedApplication(data))
                dispatch(entity.action.readByEntityApplicationId({entityApplicationId: data.applicationId}))
            },
        },
        {label: "Status", key: "applicationStatus"},
        {label: "Application ID", key: "applicationId"},
        {label: "Cloud Compute", key: "applicationCloudCompute"},
        {label: "Framework", key: "applicationFramework"},
        {label: "Language", key: "applicationLanguage"},
        {label: "Cloud Provider", key: "applicationCloudProvider"},
        {label: "Architecture", key: "applicationArchitecture"},
        {label: "Database", key: "applicationDatabase"},
    ]
    return (
            <section className="app-content-dashboard">
                <div className="title-wrapper">
                    <div className="margin-bottom">
                        <h5 className={"h5-header"} style={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingLeft: "10px"
                        }}>{workspaceState.selectedWorkspace?.workspaceName?.toUpperCase()}</h5>
                    </div>
                    <NavBarHeading/>
                </div>
                <section className="project-table-wrapper">
                    <div style={{display: "flex", gap: "1rem"}}>
                        <a onClick={() => {
                            setOpenModal(true)
                            setApplicationData(null)
                        }} className="button" style={{cursor: "pointer"}}>
                            Create New Application
                        </a>
                        {openModal && (
                            <NewApplicationModal
                                show={openModal}
                                onClose={() => setOpenModal(false)}
                                data={applicationData}
                            />
                        )}
                    </div>
                    <div className="margin-top">
                    </div>

                    <div style={{width: '100%', marginLeft: 'auto'}}>
                        <BaseTable title={"Application"} component={""}
                                   items={items ?? []}
                                   loading={applicationState.loading}
                                   refreshPage={refreshPage}
                                   showToast={false} loader={applicationState.loading}
                                   fields={fields}
                                   onCellClickAction={(value) => dispatch(application.mutation.selectedApplication(value))}
                                   actions={{view: true}}
                                   rowOptions={[{
                                       optionName: 'Create Entity', onClick: (data) => {
                                           dispatch(application.mutation.selectedApplication(data))
                                           setShowModal(true)
                                       },
                                       optionStyle:{fontSize:12}
                                   }, {
                                       optionName: 'View Application', onClick: (data: Application) => {
                                           navigate(RouteConstant.dashboard.entity.path)
                                           dispatch(application.mutation.selectedApplication(data))
                                           dispatch(entity.action.readByEntityApplicationId({entityApplicationId: data.applicationId}))
                                       },
                                       optionStyle:{fontSize:12}
                                   },
                                       {
                                           optionName: 'Edit Application', onClick: (data) => {
                                               dispatch(application.mutation.selectedApplication(data))
                                               setOpenModal(true)
                                               setApplicationData(data)
                                           },
                                           optionStyle:{fontSize:12}
                                       }, {
                                           optionName: 'Delete Application', onClick: (data) => {
                                               dispatch(application.mutation.selectedApplication(data))
                                               dispatch(base.mutation.setModalOptions({
                                                   show: true,
                                                   component: ModalConstant.deleteApplication,
                                                   payload: data
                                               }))
                                           },
                                           optionStyle:{fontSize:12}
                                       },

                                   ]}

                        />
                        {showModal && (
                            <NewEntityModal
                                show={showModal}
                                onClose={() => setShowModal(false)}
                            />
                        )}
                    </div>
                </section>
                <DashboardTabs/>
            </section>
    );
}

